/* Eden Pet Co. storefront: real Shopify cart (Ajax API), product page, and the shop buddy crew.
   Data comes from window.EDEN (layout/eden.liquid): asset base, money, free-shipping goal, delivery days,
   a light product list for suggestions, and the optional add-on product. */
(() => {
  const E = window.EDEN || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: E.currency || 'USD' });
  const money = (cents) => fmt.format((cents || 0) / 100);
  // tidy supplier variant names for the basket: no ship-from, no "(old)", English colour words, codes read as "Style 3"
  const optLabel = (t) => String(t).split(' / ').filter((x) => !/china|mainland|united states|ships? from/i.test(x)).map((x) => {
    let l = x.replace(/[（(]old[)）]/ig, '').replace(/as the picture-/i, '').replace(/\s+/g, ' ').trim();
    const pin = { zi: 'Purple', lv: 'Green', hei: 'Black', ju: 'Orange' }; const m = l.match(/^(zi|lv|hei|ju)-cat/i); if (m) l = pin[m[1].toLowerCase()];
    if (l.length > 3 && l === l.toUpperCase()) l = l.charAt(0) + l.slice(1).toLowerCase();
    if (l.length <= 3 && /\d/.test(l)) l = 'Style ' + l;
    return l.charAt(0).toUpperCase() + l.slice(1);
  }).join(' / ');
  const A = (f) => (E.base || '') + f;
  const ICONS = ['bone', 'red_heart', 'yarn', 'wrapped_gift', 'delivery_truck', 'paw_prints', 'tennis', 'house', 'heart_with_ribbon', 'sparkles', 'zzz', 'fish', 'tropical_fish', 'teddy_bear', 'soap', 'shopping_bags', 'feather', 'bird'];
  const HEADS = { dog_face: 'biscuit', cat_face: 'mochi', dog: 'biscuit', cat: 'mochi' };
  const I = (n) => (HEADS[n] ? A(`eden-head-${HEADS[n]}.webp`) : ICONS.includes(n) ? A(`eden-ico-${n}.webp`) : A(`eden-ico-paw_prints.webp`));
  const FREE = E.free || 4500;
  const PRODUCTS = E.products || [];
  const byHandle = Object.fromEntries(PRODUCTS.map((p) => [p.h, p]));
  const store = { get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : v; } catch (e) { return d; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  const sess = { get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let BUD = null;   // shop buddy hooks, set once the buddy is ready (the cart works without it)
  const img = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + (w || 300) : '');

  /* ---------- Theme: light by default, visitors can switch ---------- */
  const themeBtn = $('#themeBtn');
  const setTheme = (t) => {
    document.documentElement.setAttribute('data-theme', t);
    if (!themeBtn) return;
    const dark = t === 'dark';
    themeBtn.setAttribute('aria-pressed', String(dark));
    themeBtn.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    themeBtn.querySelector('use').setAttribute('href', dark ? '#i-sun' : '#i-moon');
  };
  let theme = store.get('eden-theme', 'light');
  setTheme(theme);
  if (themeBtn) themeBtn.addEventListener('click', () => { theme = theme === 'dark' ? 'light' : 'dark'; setTheme(theme); store.set('eden-theme', theme); });

  const menuToggle = $('#menuToggle');
  if (menuToggle) menuToggle.addEventListener('click', () => { const m = $('#menu'); const on = !m.classList.contains('is-open'); m.classList.toggle('is-open', on); m.classList.toggle('clay', on); menuToggle.setAttribute('aria-expanded', String(on)); });

  /* ---------- Cart (Shopify Ajax API) ---------- */
  let cart = { items: [], item_count: 0, total_price: 0 };
  const cartJSON = (path, body) => fetch(path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; });
  const refreshCart = () => cartJSON('/cart.js').then((c) => { cart = c; renderCart(); return c; }).catch(() => {});
  const inCart = () => new Set(cart.items.map((l) => l.handle));

  function renderCart() {
    const count = cart.item_count;
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
    const btn = $('#cartBtn'); if (btn) btn.setAttribute('aria-label', `Open basket, ${count} ${count === 1 ? 'item' : 'items'}`);
    const total = cart.total_price, pct = Math.min(total / FREE, 1);
    const bar = $('#shipBar');
    if (bar) bar.innerHTML = (total >= FREE ? 'Free U.S. shipping unlocked!' : `You're ${money(FREE - total)} away from free U.S. shipping`)
      + `<div class="ship-bar__track"><div class="ship-bar__fill" style="width:${pct * 100}%"></div><img class="ship-bar__pup" src="${I('dog')}" alt="" style="left:${4 + pct * 88}%"><img class="ship-bar__goal" src="${I('house')}" alt=""></div>`;
    const sub = $('#subtotal'); if (sub) sub.textContent = money(total);
    const foot = $('.drawer__foot'); if (foot) foot.classList.toggle('is-empty', !cart.items.length);
    const lines = $('#lines');
    if (lines) lines.innerHTML = cart.items.length ? cart.items.map((l) => `<div class="line"><a class="line__img" href="${esc(l.url)}">${l.image ? `<img src="${esc(img(l.image, 160))}" alt="">` : ''}</a>
        <div><b>${esc(l.product_title)}</b><small>${l.variant_title ? esc(optLabel(l.variant_title)) + ' · ' : ''}${money(l.final_price)}</small>
        <div class="mini-qty"><button class="clay" type="button" data-q="-1" data-k="${esc(l.key)}" data-n="${l.quantity}" aria-label="Remove one ${esc(l.product_title)}">–</button><span aria-label="Quantity">${l.quantity}</span><button class="clay" type="button" data-q="1" data-k="${esc(l.key)}" data-n="${l.quantity}" aria-label="Add one ${esc(l.product_title)}">+</button></div></div>
        <b>${money(l.final_line_price)}</b></div>`).join('')
      : `<div class="empty"><img src="${I('cat_face')}" alt=""><span>Your basket is empty. The shop cat is keeping it warm.</span><a class="btn btn--primary" href="${E.allUrl || '/collections/all'}">Browse the shop</a></div>`;
    // close the gap to free shipping with simple add-ons (no size or color to pick)
    const up = $('#upsell'); if (!up) return;
    const gap = FREE - total, have = inCart();
    const pool = [E.addon, ...PRODUCTS.filter((p) => p.single && p.a).sort((a, b) => a.p - b.p)].filter((x) => x && x.v && !have.has(x.h));
    const picks = pool.filter((x, i) => pool.findIndex((y) => y.h === x.h) === i).slice(0, 2);
    if (cart.items.length && gap > 0 && picks.length) {
      up.hidden = false;
      up.innerHTML = `<p class="upsell__title">Add one more for free shipping</p><div class="upsell__list">${picks.map((x) => `<div class="upsell__item"><div class="line__img">${x.img ? `<img src="${esc(img(x.img, 160))}" alt="">` : ''}</div><div><b>${esc(x.t)}</b><small>${money(x.p)}</small></div><button class="btn" type="button" data-add-variant="${x.v}" data-handle="${esc(x.h)}" aria-label="Add ${esc(x.t)} to basket">Add</button></div>`).join('')}</div>`;
    } else { up.hidden = true; up.innerHTML = ''; }
  }
  const lines = $('#lines');
  if (lines) lines.addEventListener('click', (e) => {
    const b = e.target.closest('[data-q]'); if (!b) return;
    b.disabled = true;
    cartJSON('/cart/change.js', { id: b.dataset.k, quantity: Math.max(0, Number(b.dataset.n) + Number(b.dataset.q)) }).then((c) => { cart = c; renderCart(); }).catch((err) => showToast(err.message, true));
  });

  /* Drawer with focus trap; focus returns to the opener */
  let lastFocus = null;
  const drawer = $('#drawer');
  const focusables = () => $$('a[href], button:not([disabled]), input, select, textarea', drawer);
  const openCart = (on) => {
    if (!drawer) { if (on) location.href = '/cart'; return; }
    document.body.classList.toggle('cart-open', on);
    if (on) { lastFocus = document.activeElement; hideToast(); if (BUD) BUD.hide(); refreshCart(); setTimeout(() => $('#closeCart').focus(), 60); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  if (drawer) {
    $('#cartBtn').addEventListener('click', (e) => { e.preventDefault(); openCart(true); });
    $('#closeCart').addEventListener('click', () => openCart(false));
    $('#scrim').addEventListener('click', () => openCart(false));
    document.addEventListener('keydown', (e) => {
      if (!document.body.classList.contains('cart-open')) return;
      if (e.key === 'Escape') { openCart(false); return; }
      if (e.key === 'Tab') {
        const f = focusables(); if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* Toast */
  let toastTimer;
  const toast = $('#toast');
  const hideToast = () => toast && toast.classList.remove('is-on');
  function showToast(text, isErr) {
    if (!toast) return;
    $('#toastText').textContent = text;
    toast.classList.toggle('is-err', !!isErr);
    toast.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 4000);
  }
  if (toast) $('#toastView').addEventListener('click', () => openCart(true));

  function flyTreat(fromEl) {
    const btn = $('#cartBtn'); if (!btn) return;
    btn.classList.remove('is-wiggle'); void btn.offsetWidth; btn.classList.add('is-wiggle');
    if (reduce || !fromEl) return;
    const a = fromEl.getBoundingClientRect(), b = btn.getBoundingClientRect();
    const f = document.createElement('img'); f.className = 'flyer'; f.src = I('bone'); f.alt = '';
    document.body.appendChild(f);
    const x0 = a.left + a.width / 2 - 22, y0 = a.top + a.height / 2 - 22, x1 = b.left + b.width / 2 - 22, y1 = b.top + b.height / 2 - 22;
    f.animate([
      { transform: `translate(${x0}px, ${y0}px) rotate(0) scale(1)` },
      { transform: `translate(${(x0 + x1) / 2}px, ${Math.min(y0, y1) - 140}px) rotate(220deg) scale(1.4)`, offset: .5 },
      { transform: `translate(${x1}px, ${y1}px) rotate(420deg) scale(.4)` },
    ], { duration: 800, easing: 'cubic-bezier(.4,0,.6,1)' }).onfinish = () => f.remove();
  }

  // add one or more variants, then show it: wiggle the basket, a toast, and the buddy's reaction
  function addItems(items, fromEl, label, handle) {
    if (fromEl) fromEl.setAttribute('aria-busy', 'true');
    return cartJSON('/cart/add.js', { items }).then(() => refreshCart()).then(() => {
      flyTreat(fromEl);
      showToast(`${label || 'Item'} added to basket`);
      if (BUD && (!fromEl || !fromEl.closest('.drawer, #buddyBubble'))) BUD.suggest(handle);
    }).catch((err) => showToast(err.message, true)).finally(() => fromEl && fromEl.removeAttribute('aria-busy'));
  }

  /* Contact and review forms: a person who types gets a "real-person" stamp (bots posting straight to /contact never run this),
     and the hidden "Website" box catches bots that fill every field. The Gmail filters sort on the stamp. */
  $$('[data-human]').forEach((stamp) => {
    const f = stamp.form, hp = f && f.querySelector('.hp input'); if (!f) return;
    const mark = () => { stamp.value = hp && hp.value ? 'bot-trap' : ['real', 'person', 'eden'].join('-'); };
    f.addEventListener('keydown', mark, { once: true }); f.addEventListener('submit', mark);
  });

  /* Global clicks: quick add, kits, favorites */
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      const p = byHandle[add.dataset.handle] || (E.addon && E.addon.h === add.dataset.handle ? E.addon : null);
      addItems([{ id: Number(add.dataset.addVariant), quantity: 1 }], add, p ? p.t : add.dataset.title, add.dataset.handle);
      return;
    }
    const kit = e.target.closest('[data-kit]');
    if (kit) {
      e.preventDefault();
      const ids = kit.dataset.kit.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
      if (ids.length) addItems(ids, kit, kit.dataset.title || 'Kit', null);
      return;
    }
    const fav = e.target.closest('[data-fav]');
    if (fav) {
      const favs = new Set((store.get('eden-favs', '') || '').split(',').filter(Boolean));
      const on = !favs.has(fav.dataset.fav); on ? favs.add(fav.dataset.fav) : favs.delete(fav.dataset.fav);
      store.set('eden-favs', [...favs].join(',')); fav.setAttribute('aria-pressed', String(on));
    }
  });
  (() => { const favs = new Set((store.get('eden-favs', '') || '').split(',')); $$('[data-fav]').forEach((b) => b.setAttribute('aria-pressed', String(favs.has(b.dataset.fav)))); })();

  /* Product shelves: prev/next buttons scroll one screen of cards */
  $$('[data-shelf]').forEach((shelf) => {
    const sec = shelf.closest('section'), prev = sec && $('[data-shelf-prev]', sec), next = sec && $('[data-shelf-next]', sec);
    if (!prev || !next) return;
    const sync = () => { prev.disabled = shelf.scrollLeft < 4; next.disabled = shelf.scrollLeft + shelf.clientWidth >= shelf.scrollWidth - 4; };
    prev.addEventListener('click', () => shelf.scrollBy({ left: -shelf.clientWidth, behavior: reduce ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => shelf.scrollBy({ left: shelf.clientWidth, behavior: reduce ? 'auto' : 'smooth' }));
    shelf.addEventListener('scroll', sync, { passive: true }); sync();
  });

  /* Collection sort */
  const sortSel = $('#sortSel');
  if (sortSel) {
    const go = (v) => { const u = new URL(location.href); u.searchParams.set('sort_by', v); u.searchParams.delete('page'); location.href = u.toString(); };
    sortSel.addEventListener('change', () => go(sortSel.value));
    // the browser's own option list can't be themed (white box, blue highlight), so draw a menu and keep the select for no-JS
    const opts = [...sortSel.options], lab = sortSel.closest('label');
    const dd = document.createElement('div'); dd.className = 'dd';
    dd.innerHTML = `<span class="dd__lab" id="ddLab">Sort</span><button type="button" class="dd__btn" aria-haspopup="listbox" aria-expanded="false" aria-labelledby="ddLab ddVal"><span id="ddVal">${esc(opts[sortSel.selectedIndex].text)}</span><svg class="icon" aria-hidden="true"><use href="#i-arrow"/></svg></button>`
      + `<ul class="dd__list" role="listbox" aria-labelledby="ddLab" tabindex="-1" hidden>${opts.map((o, i) => `<li role="option" id="ddo${i}" data-v="${esc(o.value)}" aria-selected="${i === sortSel.selectedIndex}">${esc(o.text)}</li>`).join('')}</ul>`;
    lab.replaceWith(dd);
    const btn = dd.querySelector('.dd__btn'), list = dd.querySelector('.dd__list'), items = [...list.children];
    let at = sortSel.selectedIndex;
    const mark = () => { items.forEach((li, i) => li.classList.toggle('is-active', i === at)); list.setAttribute('aria-activedescendant', 'ddo' + at); };
    const open = (on) => { list.hidden = !on; btn.setAttribute('aria-expanded', on); if (on) { at = sortSel.selectedIndex; mark(); list.focus(); } };
    const pick = (i) => { open(false); btn.focus(); if (i !== sortSel.selectedIndex) go(opts[i].value); };
    btn.addEventListener('click', () => open(list.hidden));
    btn.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(true); } });
    list.addEventListener('click', (e) => { const li = e.target.closest('li'); if (li) pick(items.indexOf(li)); });
    list.addEventListener('mousemove', (e) => { const li = e.target.closest('li'); if (li) { at = items.indexOf(li); mark(); } });
    list.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') at = Math.min(items.length - 1, at + 1);
      else if (e.key === 'ArrowUp') at = Math.max(0, at - 1);
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(at); return; }
      else if (e.key === 'Escape' || e.key === 'Tab') { open(false); if (e.key === 'Escape') btn.focus(); return; }
      else return;
      e.preventDefault(); mark();
    });
    document.addEventListener('click', (e) => { if (!dd.contains(e.target)) open(false); });
  }

  /* ---------- Product page ---------- */
  const pj = $('#eden-product-json');
  if (pj) {
    const product = JSON.parse(pj.textContent);
    const form = $('#pdpForm'), addBtn = $('#pdpAdd'), buyBtn = $('#pdpBuy'), idInput = $('#pdpVariant');
    let qty = 1;
    const chosen = {};
    $$('[data-opt]').forEach((row) => { const p = row.querySelector('[aria-pressed="true"]'); chosen[row.dataset.opt] = p ? p.dataset.v : null; });
    const findVariant = () => product.variants.find((v) => v.options.every((o, i) => chosen[product.options[i]] === o)) || null;
    let variant = product.variants.find((v) => String(v.id) === idInput.value) || product.variants[0];
    const addonBox = $('#addAddon');
    // swap the big photo (drop the responsive srcset so the browser shows the chosen one)
    const showShot = (src) => { const shot = $('#shot'); if (!shot || !src) return; shot.removeAttribute('srcset'); shot.removeAttribute('sizes'); shot.src = src; };
    const label = () => {
      if (!variant || !variant.available) {
        [addBtn, buyBtn].forEach((b) => { if (b) { b.textContent = variant ? 'Sold out' : 'Unavailable'; b.disabled = true; } });
        return;
      }
      addBtn.disabled = false; addBtn.textContent = 'Add to basket';
      const extra = addonBox && addonBox.checked ? Number(addonBox.dataset.price || 0) : 0;
      if (buyBtn) { buyBtn.disabled = false; buyBtn.textContent = `Buy it now · ${money(variant.price * qty + extra)}`; }
    };
    const update = () => {
      variant = findVariant();
      if (variant) {
        idInput.value = variant.id;
        $('#pdpPrice').innerHTML = money(variant.price) + (variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s><span class="save">Save ${money(variant.compare_at_price - variant.price)}</span>` : '');
        if (variant.featured_image) showShot(img(variant.featured_image.src, 1100));
        const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u.toString());
        const stickyPrice = $('#stickyPrice'); if (stickyPrice) stickyPrice.textContent = money(variant.price);
      }
      label(); shipHint();
    };
    // supplier style codes (Style 31, Style A9...) come in random order: show them 1, 2, 3...
    $$('.opt--sw [data-opt]').forEach((row) => {
      const bs = Array.from(row.querySelectorAll('button'));
      if (!bs.every((b) => /^Style /.test(b.dataset.label || ''))) return;
      const key = (b) => (b.dataset.label || '').replace(/^Style /, '').replace(/\d+/g, (d) => d.padStart(4, '0'));
      bs.sort((a, b) => key(a).localeCompare(key(b))).forEach((b) => row.appendChild(b));
    });
    $$('[data-opt]').forEach((row) => row.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      row.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      chosen[row.dataset.opt] = b.dataset.v;
      const lab = $(`[data-optval="${CSS.escape(row.dataset.opt)}"]`); if (lab) lab.textContent = b.dataset.label || b.dataset.v;
      update();
    }));
    const thumbs = $('#thumbs');
    if (thumbs) thumbs.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      $$('#thumbs button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      showShot(b.dataset.src);
    });
    $('#qMinus').addEventListener('click', () => { qty = Math.max(1, qty - 1); $('#qVal').textContent = qty; $('#pdpQty').value = qty; label(); });
    $('#qPlus').addEventListener('click', () => { qty += 1; $('#qVal').textContent = qty; $('#pdpQty').value = qty; label(); });
    if (addonBox) addonBox.addEventListener('change', label);
    // delivery estimate and free-shipping gap
    const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    const day = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const eta = $('[data-eta]'); if (eta) eta.textContent = `Order today, arrives ${day(addBiz(new Date(), E.etaMin || 5))} – ${day(addBiz(new Date(), E.etaMax || 9))}`;
    function shipHint() {
      const el = $('[data-ship-hint]'); if (!el || !variant) return;
      const gap = FREE - cart.total_price - variant.price;
      el.textContent = gap > 0 ? `Add ${money(gap)} more for free U.S. shipping` : 'This order ships free in the U.S.';
    }
    const picked = () => {
      const items = [{ id: variant.id, quantity: qty }];
      if (addonBox && addonBox.checked) items.push({ id: Number(addonBox.value), quantity: 1 });
      return items;
    };
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!variant || !variant.available) return;
      addItems(picked(), addBtn, product.title, product.handle);
    });
    // buy it now: put it in the basket and go straight to checkout
    const buyNow = (el) => {
      if (!variant || !variant.available || el.getAttribute('aria-busy') === 'true') return;
      el.setAttribute('aria-busy', 'true');
      cartJSON('/cart/add.js', { items: picked() }).then(() => { location.href = '/checkout'; })
        .catch((err) => { el.removeAttribute('aria-busy'); showToast(err.message, true); });
    };
    if (buyBtn) buyBtn.addEventListener('click', () => buyNow(buyBtn));
    // phones: a sticky add bar once the main button scrolls away
    const sticky = $('#pdpSticky');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver((en) => en.forEach((x) => {
        const on = !x.isIntersecting && x.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); document.body.classList.toggle('has-sticky', on && matchMedia('(max-width: 860px)').matches);
        sticky.setAttribute('aria-hidden', String(!on)); $$('#pdpStickyAdd, #pdpStickyBuy').forEach((b) => { b.tabIndex = on ? 0 : -1; });
      })).observe(buyBtn || addBtn);
      $('#pdpStickyAdd').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : addBtn.click());
      const sBuy = $('#pdpStickyBuy'); if (sBuy) sBuy.addEventListener('click', () => buyNow(sBuy));
    }
    update();
  }

  /* ---------- Reveal on scroll ---------- */
  $$('.stagger').forEach((g) => Array.from(g.children).forEach((c, i) => c.style.setProperty('--i', i % 8)));
  const revealEls = $$('.reveal, .stagger');
  if (reduce || !('IntersectionObserver' in window)) revealEls.forEach((el) => el.classList.add('is-in'));
  else {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => io.observe(el));
  }
  $$('a[data-scroll]').forEach((a) => a.addEventListener('click', (e) => { const t = document.getElementById(a.getAttribute('href').slice(1)); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); } }));

  /* ---------- Ambient: paw trail, scroll progress, floating accents ---------- */
  const main = $('main');
  const pawSvg = '<svg viewBox="0 0 40 40" fill="currentColor" aria-hidden="true"><ellipse cx="20" cy="27" rx="9" ry="7.5"/><circle cx="8.5" cy="17" r="4.2"/><circle cx="15" cy="9.5" r="4.2"/><circle cx="25" cy="9.5" r="4.2"/><circle cx="31.5" cy="17" r="4.2"/></svg>';
  const paws = (() => {
    if (!main) return { tick() {} };
    const layer = document.createElement('div'); layer.className = 'paws'; layer.setAttribute('aria-hidden', 'true'); main.appendChild(layer);
    let next = 500, side = 0;
    return { tick() {
      if (reduce) return;
      const y = window.scrollY + window.innerHeight * .55 - main.offsetTop, max = main.offsetHeight - 80;
      while (next < y && next < max) {
        const p = document.createElement('div'); p.className = 'paw';
        const edge = Math.max(8, (window.innerWidth - 1200) / 2 - 36);
        p.style.left = (edge + (side % 2) * 18) + 'px'; p.style.top = next + 'px'; p.style.setProperty('--rot', (side % 2 ? 10 : -10) + 'deg');
        p.innerHTML = pawSvg; layer.appendChild(p); next += 150; side += 1;
      }
    } };
  })();
  let ticking = false;
  const progress = $('#progress');
  window.addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      paws.tick();
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (progress) progress.style.setProperty('--p', max > 0 ? (window.scrollY / max).toFixed(3) : 0);
      ticking = false;
    });
  }, { passive: true });
  window.addEventListener('pointermove', (e) => {
    if (reduce) return;
    const dx = e.clientX / window.innerWidth - .5, dy = e.clientY / window.innerHeight - .5;
    $$('.float').forEach((el, i) => { el.style.translate = `${dx * (14 + i * 6)}px ${dy * (14 + i * 6)}px`; });
  }, { passive: true });

  /* ---------- Shop buddy ---------- */
  const buddy = $('#buddy');
  if (!buddy || !window.TWPets || E.buddy === false) { refreshCart(); return; }
  const BUDDIES = [
    { id: 'dog', name: 'Biscuit', kind: 'pup' }, { id: 'poodle', name: 'Pepper', kind: 'pup' },
    { id: 'cat', name: 'Mochi', kind: 'kitty' }, { id: 'black_cat', name: 'Shadow', kind: 'kitty' },
  ];
  const returning = store.get('eden-buddy-seen', '') === '1';
  let bSel = BUDDIES.find((b) => b.id === store.get('eden-buddy', E.defaultBuddy || 'cat')) || BUDDIES[0];
  let bName = store.get('eden-buddy-name', bSel.name) || bSel.name;
  let bOn = store.get('eden-buddy-on', 'on') !== 'off';
  const bubble = $('#buddyBubble'), panel = $('#buddyPanel');
  const anim = TWPets.Animator($('#buddySvg'), bSel.id, 'bd_');
  const hover = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const W = () => (window.innerWidth <= 820 ? 78 : 124);
  const H = () => W() * 175 / 210;
  const home = () => ({ x: 96, y: window.innerHeight - (document.body.classList.contains('has-sticky') ? 140 : 58) });
  let bx = home().x, by = home().y, tgx = bx, tgy = by, lastMove = Date.now(), mode = 'follow', modeUntil = 0, attachEl = null;
  const ACT = { 'is-walk': 'walk', 'is-run': 'run', 'is-sit': 'sit', 'is-scratch': 'paw', 'is-happy': 'happy', 'is-sleep': 'sleep', 'is-tilt': 'tilt' };
  let oneShotUntil = 0;
  const setState = (st) => {
    if ((st === 'is-happy' || st === 'is-tilt') && !buddy.classList.contains(st)) oneShotUntil = Date.now() + (st === 'is-happy' ? 1000 : 1500);
    Object.keys(ACT).forEach((c) => buddy.classList.toggle(c, c === st));
    anim.set(ACT[st]);
  };
  function applyBuddy() {
    anim.setPet(bSel.id); TWPets.still($('#buddyBtnSvg'), bSel.id, 'sit', 'bb_');
    $('#buddyBtnLabel').textContent = bName;
    $('#buddyBtn').setAttribute('aria-label', `Shop buddy ${bName}: change or hide`);
    buddy.hidden = !bOn; if (!bOn) hideBubble();
  }
  function spawn(cls, x, y, extra) { if (reduce) return; const el = document.createElement(extra && extra.img ? 'img' : 'span'); el.className = cls; if (extra && extra.img) { el.src = extra.img; el.alt = ''; } el.style.left = x + 'px'; el.style.top = y + 'px'; if (extra && extra.vars) Object.entries(extra.vars).forEach(([k, v]) => el.style.setProperty(k, v)); el.addEventListener('animationend', () => el.remove()); document.body.appendChild(el); }
  function hearts() { const w = W(); for (let i = 0; i < 4; i++) spawn('b-heart', bx - 10 + i * 8, by - w * .6, { img: I('red_heart'), vars: { '--dx': (i * 14 - 20) + 'px' } }); }
  function scratchMarks(x, y) { for (let i = 0; i < 3; i++) spawn('b-scratch', x + i * 7, y + i * 4, { vars: { '--r': (30 + i * 12) + 'deg' } }); }

  /* Speech bubble: greetings sit beside the paw button, product tips ride above the buddy */
  let bubbleTimer;
  function showBubble(html, extra, ms, kind) {
    if (!bOn) return;
    bubble.dataset.kind = kind || '';
    $('#buddyText').innerHTML = html; $('#buddyExtra').innerHTML = extra || '';
    bubble.classList.add('is-on'); placeBubble();
    clearTimeout(bubbleTimer); if (ms) bubbleTimer = setTimeout(hideBubble, ms);
  }
  function hideBubble() { if (!bubble) return; bubble.classList.remove('is-on'); $$('.buddy-pick').forEach((c) => c.classList.remove('buddy-pick')); }
  function placeBubble() {
    if (!bubble.classList.contains('is-on')) return;
    const bw = bubble.offsetWidth, bh = bubble.offsetHeight;
    if (!bubble.dataset.kind || bubble.dataset.kind === 'upsell') {
      // docked beside the buddy button in the corner, so it never covers the products
      const b = $('#buddyBtn').getBoundingClientRect();
      bubble.dataset.side = 'left';
      bubble.style.maxWidth = Math.min(window.innerWidth <= 600 ? 250 : 320, window.innerWidth - b.right - 26) + 'px';
      bubble.style.transform = `translate(${b.right + 14}px, ${b.bottom - bubble.offsetHeight}px)`;
      return;
    }
    bubble.style.maxWidth = '';
    const left = Math.min(Math.max(12, bx - 36), window.innerWidth - bw - 12);
    const above = by - H() - bh - 14 > 70;
    bubble.dataset.side = above ? 'above' : 'below';
    bubble.style.transform = `translate(${left}px, ${above ? by - H() - bh - 14 : by + 16}px)`;
    bubble.style.setProperty('--tail', Math.min(Math.max(16, bx - left - 9), bw - 34) + 'px');
  }
  $('#buddyBubbleClose').addEventListener('click', () => { if (bubble.dataset.kind === 'upsell') { UPSELL.muted = true; sess.set('eden-up-off', '1'); } hideBubble(); });
  bubble.addEventListener('click', (e) => { if (e.target.closest('a,[data-add-variant]')) setTimeout(hideBubble, 50); });

  /* Picker panel */
  function renderPicks() {
    $('#buddyPicks').innerHTML = BUDDIES.map((b) => `<button type="button" data-buddy="${b.id}" aria-pressed="${b.id === bSel.id}"><svg viewBox="30 8 190 164" data-pet="${b.id}" aria-hidden="true"></svg>${b.name}</button>`).join('');
    $$('#buddyPicks svg').forEach((el) => TWPets.still(el, el.dataset.pet, 'sit', 'pk_' + el.dataset.pet + '_'));
  }
  function openPanel(on) {
    panel.hidden = !on; $('#buddyBtn').setAttribute('aria-expanded', String(on));
    if (on) { renderPicks(); $('#buddyName').value = bName; $('#buddyShow').checked = bOn; hideBubble(); $('#buddyPicks button[aria-pressed="true"]').focus(); } else $('#buddyBtn').focus();
  }
  $('#buddyBtn').addEventListener('click', () => openPanel(panel.hidden));
  $('#buddyPanelClose').addEventListener('click', () => openPanel(false));
  $('#buddyPicks').addEventListener('click', (e) => {
    const b = e.target.closest('[data-buddy]'); if (!b) return;
    const old = bSel; bSel = BUDDIES.find((x) => x.id === b.dataset.buddy);
    if (!$('#buddyName').value.trim() || $('#buddyName').value.trim() === old.name) $('#buddyName').value = bSel.name;
    $$('#buddyPicks button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    anim.setPet(bSel.id);
  });
  $('#buddySave').addEventListener('click', () => {
    bName = $('#buddyName').value.trim() || bSel.name; bOn = $('#buddyShow').checked;
    store.set('eden-buddy', bSel.id); store.set('eden-buddy-name', bName); store.set('eden-buddy-on', bOn ? 'on' : 'off');
    applyBuddy(); openPanel(false);
    if (bOn) { setState('is-happy'); hearts(); setTimeout(() => showBubble(`Hi, I'm <b>${esc(bName)}</b>! I'll sniff out goodies for you.`, '', 3500), 350); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { if (!panel.hidden) openPanel(false); hideBubble(); } });

  /* Where to go: click or tap anywhere and the buddy comes over */
  window.addEventListener('pointermove', () => { lastMove = Date.now(); }, { passive: true });
  ['scroll', 'keydown', 'touchstart'].forEach((ev) => window.addEventListener(ev, () => { lastMove = Date.now(); }, { passive: true }));
  document.addEventListener('pointerdown', (e) => {
    lastMove = Date.now();
    if (!bOn || e.target.closest('#buddyPanel,#buddyBtn,#buddyBubble,.drawer,.scrim')) return;
    attachEl = null; mode = 'trot'; modeUntil = Date.now() + 4000; nextWander = 0; clickTrip = true;
    // runs to the tap, then moves on to a free spot about a second later (clickTrip)
    tgx = Math.min(Math.max(e.clientX + 24, W()), window.innerWidth - W() / 2); tgy = Math.min(Math.max(e.clientY + 30, 110), window.innerHeight - 20);
    const far = Math.hypot(tgx - bx, tgy - by); tripRun = far > 320 || (far > 160 && Math.random() < .4);
  });

  /* Upsell: after an add, trot to a related product on screen and paw at it (calm: first add, then at most every 90s, 3 per visit) */
  const COMPLEMENT = { Beds: ['Toys', 'Care'], Toys: ['Bowls', 'Beds'], Walk: ['Care', 'Toys'], Bowls: ['Toys', 'Care'], Care: ['Toys', 'Walk'] };
  function relatedFor(handle) {
    const base = byHandle[handle], have = inCart();
    return PRODUCTS.filter((x) => x.h !== handle && x.a && !have.has(x.h)).map((x) => {
      let score = 0;
      if (base && base.pet && x.pet === base.pet) score += 3;
      if (base && (COMPLEMENT[base.type] || []).includes(x.type)) score += 2;
      if (base && x.type && x.type === base.type) score -= 1;
      if (x.single) score += 1;
      if (x.c > x.p) score += 1;
      return { x, score };
    }).sort((a, b) => b.score - a.score).map((o) => o.x);
  }
  const UPSELL = { shown: +(sess.get('eden-up-n') || 0), last: +(sess.get('eden-up-t') || 0), muted: sess.get('eden-up-off') === '1' };
  function suggestAfterAdd(handle) {
    if (!bOn) return;
    setState('is-happy'); hearts();
    const now = Date.now();
    if (UPSELL.muted || UPSELL.shown >= 3 || (UPSELL.shown && now - UPSELL.last < 90000)) return;
    const picks = relatedFor(handle); if (!picks.length) return;
    UPSELL.shown++; UPSELL.last = now; sess.set('eden-up-n', UPSELL.shown); sess.set('eden-up-t', now);
    let pick = null, el = null;
    for (const x of picks.slice(0, 6)) {
      const a = document.querySelector(`.card .card__media[data-handle="${CSS.escape(x.h)}"]`);
      if (!a) continue;
      const r = a.getBoundingClientRect();
      if (r.top > 80 && r.bottom < window.innerHeight - 20) { pick = x; el = a.closest('.card'); break; }
    }
    pick = pick || picks[0];
    const btn = pick.single ? `<button class="btn btn--cta" type="button" data-add-variant="${pick.v}" data-handle="${esc(pick.h)}">Add · ${money(pick.p)}</button>` : `<a class="btn btn--cta" href="${esc(pick.u)}">Choose options</a>`;
    const extra = `<a class="buddy-bubble__prod" href="${esc(pick.u)}">${pick.img ? `<img src="${esc(img(pick.img, 120))}" alt="">` : ''}<span><b>${esc(pick.t)}</b><small>${money(pick.p)}${pick.c > pick.p ? ` · <s>${money(pick.c)}</s>` : ''}</small></span></a><div class="buddy-bubble__actions"><a class="btn" href="${esc(pick.u)}">View</a>${btn}</div>`;
    const line = bSel.kind === 'kitty' ? `<b>${esc(bName)}</b> is pawing at this one… it pairs purr-fectly!` : `Psst! <b>${esc(bName)}</b> sniffed out a match for that.`;
    setTimeout(() => {
      $$('.buddy-pick').forEach((c) => c.classList.remove('buddy-pick'));
      if (el) { el.classList.add('buddy-pick'); attachEl = el; attachKind = 'card'; mode = 'attach'; modeUntil = Date.now() + 8000; tripRun = true; }
      showBubble(line, extra, 7000, 'upsell');
    }, reduce ? 0 : 650);
  }

  /* Welcome: once per visit; returning shoppers hear about their basket */
  if (!sess.get('eden-greeted')) setTimeout(() => {
    if (!bOn) return;
    sess.set('eden-greeted', '1');
    const n = cart.item_count;
    if (returning && n) showBubble(`Welcome back! <b>${esc(bName)}</b> kept your basket warm: ${n} ${n === 1 ? 'item' : 'items'} waiting.`, '<div class="buddy-bubble__actions"><button class="btn btn--cta" type="button" id="buddyOpenCart">Open basket</button></div>', 7000);
    else if (returning) showBubble(`<b>${esc(bName)}</b> missed you!`, '', 3500);
    else if (E.halloween) showBubble(`Boo! Happy Halloween from <b>${esc(bName)}</b>. ${hover ? 'Click' : 'Tap'} anywhere and I'll come running.`, '', 4000);
    else showBubble(`Hi! I'm <b>${esc(bName)}</b>. ${hover ? 'Click' : 'Tap'} anywhere and I'll come running.`, '', 4000);
    store.set('eden-buddy-seen', '1');
  }, 1800);
  document.addEventListener('click', (e) => { if (e.target.closest('#buddyOpenCart')) { hideBubble(); openCart(true); } });

  // where the buddy may sit or nap: the empty margin beside the page on wide screens, else next to its button in the corner
  // on phones (no side margins) it perches on top of its own round button, the smallest footprint possible
  const perch = () => { const b = $('#buddyBtn').getBoundingClientRect(); return { x: b.left + b.width / 2, y: b.top + 10 }; };
  const restX = () => { const wrap = $('main .wrap'), gut = wrap ? wrap.getBoundingClientRect().left : 0, vw = window.innerWidth; if (hover && gut > W() * .75) return bx > vw / 2 ? vw - gut / 2 : gut / 2; return home().x + 30; };

  /* New page: the buddy runs in from the side it left from */
  function buddyEnter() {
    if (!bOn || reduce) return;
    const w = W(), vw = window.innerWidth, vh = window.innerHeight;
    // runs in along the bottom edge to its resting spot (side margin or beside its button), never onto the products
    let sx = restX(), sy = home().y;
    if (!hover) ({ x: sx, y: sy } = perch());
    sx = Math.min(Math.max(sx, w * .6), vw - w * .6); sy = Math.min(Math.max(sy, 140), vh - 30);
    const lastX = Number(sess.get('eden-bx') || 0);
    bx = lastX > vw / 2 ? -w : vw + w; by = sy;
    tgx = sx; tgy = sy; mode = 'enter'; modeUntil = Date.now() + 6000; tripRun = true;
  }
  window.addEventListener('pagehide', () => sess.set('eden-bx', Math.round(bx)));

  /* Hide & seek: now and then one pal hides behind a block; find all four once */
  const SEEKERS = [['mochi', 'Mochi'], ['shadow', 'Shadow'], ['biscuit', 'Biscuit'], ['pepper', 'Pepper']];
  const found = new Set((store.get('eden-seek', '') || '').split(',').filter(Boolean));
  let seekEl = null, seekLoop = 0, seekTimer = 0;
  const clipped = (el) => { for (let n = el; n && n !== document.body; n = n.parentElement) { const cs = getComputedStyle(n); if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') return true; } return false; };
  function seekHost() {
    // never over product cards: a peeking head there would cover the row above it
    const hosts = $$('main .review, main .head, main .crew figure, main .stage__card').filter((h) => { const r = h.getBoundingClientRect(); return r.width > 120 && r.height > 60 && !clipped(h); });
    return hosts.length ? hosts[Math.floor(Math.random() * hosts.length)] : null;
  }
  function removeSeek() { clearInterval(seekLoop); if (seekEl) seekEl.remove(); seekEl = null; }
  function scheduleSeek(ms) { clearTimeout(seekTimer); if (found.size < SEEKERS.length) seekTimer = setTimeout(spawnSeek, ms); }
  function spawnSeek() {
    removeSeek();
    const left = SEEKERS.filter(([id]) => !found.has(id)), host = seekHost();
    if (!left.length || !host) return;
    const [id, name] = left[Math.floor(Math.random() * left.length)];
    const face = (n) => A(`eden-${id}-front${n}.webp`);
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    seekEl = document.createElement('button');
    seekEl.type = 'button'; seekEl.className = 'seek'; seekEl.setAttribute('aria-label', 'Someone is hiding here. Tap to find them!');
    // over a heading, hide at the empty right end so the title stays readable
    seekEl.style.left = (host.classList.contains('head') ? 72 + Math.random() * 16 : 8 + Math.random() * 70) + '%';
    seekEl.innerHTML = `<span class="seek__win"><img src="${face(1)}" alt=""></span>`;
    host.appendChild(seekEl);
    const im = seekEl.querySelector('img'), el = seekEl;
    requestAnimationFrame(() => el.classList.add('is-up'));
    let t = 0;
    seekLoop = setInterval(() => { t++; el.classList.toggle('is-up', t % 5 !== 3); im.src = face(t % 7 === 0 ? 3 : 1); }, 900);
    el.addEventListener('click', () => {
      clearInterval(seekLoop); el.classList.add('is-up', 'is-found'); im.src = face(3);
      found.add(id); store.set('eden-seek', [...found].join(','));
      const r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top;
      for (let i = 0; i < 5; i++) spawn('b-heart', cx - 20 + i * 9, cy - 10, { img: I('red_heart'), vars: { '--dx': (i * 12 - 24) + 'px' } });
      const msg = document.createElement('span'); msg.className = 'seek-msg';
      msg.textContent = found.size < SEEKERS.length ? `You found ${name}! ${found.size} of ${SEEKERS.length} hiding pals` : 'You found the whole crew! Thanks for playing';
      msg.style.left = cx + 'px'; msg.style.top = (cy - 46) + 'px';
      document.body.appendChild(msg); setTimeout(() => msg.remove(), 2700);
      if (bOn) { setState('is-happy'); hearts(); }
      setTimeout(() => { if (seekEl === el) removeSeek(); }, 900);
      scheduleSeek(45000 + Math.random() * 30000);
    });
  }
  scheduleSeek(14000);
  if (!hover) setInterval(() => {
    const vis = $$('main .card').filter((c) => { const r = c.getBoundingClientRect(); return r.top > 80 && r.bottom < window.innerHeight; });
    if (!vis.length) return;
    const c = vis[Math.floor(Math.random() * vis.length)]; c.classList.add('is-peek'); setTimeout(() => c.classList.remove('is-peek'), 1800);
  }, 11000);

  /* Sidewalk under the hero: the pals who aren't today's buddy chase real products */
  (function runSidewalk() {
    const lane = $('.sidewalk');
    if (!lane || reduce || !TWPets.CLIPS) return;
    const PX = window.innerWidth <= 600 ? .56 : .8; // pals drawn big enough to read as pets
    const isCat = (id) => id === 'cat' || id === 'black_cat';
    const forPet = (pet, types) => {
      const a = PRODUCTS.filter((p) => p.a && p.img && p.pet === pet);
      const typed = a.filter((p) => types.includes(p.type));
      return typed.length ? typed : a.length ? a : PRODUCTS.filter((p) => p.a && p.img);
    };
    const mk = () => { const el = document.createElement('div'); el.className = 'sw-el'; el.innerHTML = '<img alt="">'; lane.appendChild(el); return el; };
    function prodEl(pr) {
      const el = document.createElement('a'); el.className = 'sw-el sw-prod'; el.href = pr.u; el.tabIndex = -1;
      el.innerHTML = `<img src="${esc(img(pr.img, 160))}" alt=""><span class="sw-tag">${esc(pr.t)} · <b>${money(pr.p)}</b></span>`;
      lane.appendChild(el); return el;
    }
    function pet(id) {
      const el = mk(), C = TWPets.CLIPS[id], im = el.firstChild;
      return { el, set(act, dist) {
        const fr = C.c[act], f = fr[Math.floor(dist / (act === 'run' ? 26 : 16)) % fr.length], [n, w, h, ax, lift] = f;
        if (im.dataset.n !== n) { im.src = C.dir + n + '.webp'; im.dataset.n = n; }
        el.style.width = w * PX + 'px'; el.style.height = h * PX + 'px'; el.style.marginLeft = -ax * w * PX + 'px'; el.style.bottom = 12 + lift * PX + 'px';
      } };
    }
    let onScreen = true;
    new IntersectionObserver(([e]) => { onScreen = e.isIntersecting; }).observe(lane);
    function scene() {
      if (!onScreen || document.hidden) { setTimeout(scene, 1500); return; }
      const pool = Object.keys(TWPets.CLIPS).filter((id) => id !== bSel.id).sort(() => Math.random() - .5);
      if (!pool.length) return;
      const kind = ['chase', 'treat', 'stroll'][Math.floor(Math.random() * 3)], LW = lane.clientWidth;
      const a = pet(pool[0]), b = kind === 'stroll' && pool[1] ? pet(pool[1]) : null;
      const list = kind === 'stroll' ? [] : forPet(isCat(pool[0]) ? 'cats' : 'dogs', kind === 'chase' ? ['Toys'] : ['Bowls', 'Toys', 'Treats']);
      const pr = list.length ? list[Math.floor(Math.random() * list.length)] : null;
      const toy = pr ? prodEl(pr) : null;
      let paused = false;
      if (toy) { toy.addEventListener('pointerenter', () => { paused = true; }); toy.addEventListener('pointerleave', () => { paused = false; }); }
      const speed = kind === 'chase' ? 140 : 62, gap = kind === 'chase' ? 140 : kind === 'treat' ? 96 : 110;
      let x = LW + 60, t0 = performance.now(), prev = t0;
      (function step(now) {
        const dt = Math.min(.05, (now - prev) / 1000); prev = now; if (!paused) x -= speed * dt;
        const dist = LW + 60 - x, t = (now - t0) / 1000;
        if (toy) {
          const tx = x - gap, hop = paused ? 0 : kind === 'chase' ? Math.abs(Math.sin(t * 5)) * 16 : Math.max(0, Math.sin(t * 3.2)) * 10;
          toy.style.transform = `translate(${tx - toy.offsetWidth / 2}px, ${-hop}px)`;
          toy.classList.toggle('is-tag', tx > LW * .3 && tx < LW * .62);
        }
        a.set(kind === 'chase' ? 'run' : 'walk', dist); a.el.style.transform = `translateX(${x}px)`;
        if (b) { b.set('walk', dist + 7); b.el.style.transform = `translateX(${x + gap}px)`; }
        if (x + gap < -160) { [a.el, b && b.el, toy].forEach((el) => el && el.remove()); setTimeout(scene, 2500 + Math.random() * 3500); return; }
        requestAnimationFrame(step);
      })(t0);
    }
    setTimeout(scene, 1200);
  })();

  /* Movement loop */
  const SPEED = { stroll: 60, walk: 75, run: 240 };
  let lastT = performance.now(), clickTrip = false, arrivedAt = 0, tripRun = false, nextWander = 0, attachKind = 'card', lastBasketVisit = Number(sess.get('eden-basket-visit') || 0), basketNudge = false;
  function attachTarget(r, w) {
    if (attachKind === 'basket') return { x: Math.max(w, r.left - w * .3), y: r.bottom + H() * .95 };
    return { x: Math.min(r.right - 12, window.innerWidth - w / 2), y: r.top + w * .75 };
  }
  // empty places the buddy may stop at (feet position): side margins, the blank end of a section heading,
  // the sidewalk under the hero, and its corner by the button
  let onPageSpot = false;
  // a spot beside a heading or on the sidewalk scrolls away with the page: when the shopper scrolls, find a new one
  window.addEventListener('scroll', () => { if (onPageSpot && mode !== 'attach') { onPageSpot = false; nextWander = Date.now() + 500; } }, { passive: true });
  function freeSpots() {
    const vw = window.innerWidth, vh = window.innerHeight, w = W(), out = [], h = home();
    const wrap = $('main .wrap'), gut = wrap ? wrap.getBoundingClientRect().left : 0;
    if (gut > w * .75) for (const side of [gut / 2, vw - gut / 2]) out.push({ x: side, y: vh * (.3 + Math.random() * .6), fixed: true });
    else if (!hover) out.push({ ...perch(), fixed: true });
    else out.push({ x: h.x + 30 + Math.random() * Math.min(140, vw * .2), y: h.y, fixed: true }); // no side margins: its corner by the button
    const lane = $('.sidewalk');
    if (lane) { const r = lane.getBoundingClientRect(); if (r.bottom > 120 && r.bottom < vh - 10) out.push({ x: r.left + w + Math.random() * Math.max(0, r.width - 2 * w), y: r.bottom - 10 }); }
    $$('main .head').forEach((hd) => {
      const r = hd.getBoundingClientRect(), t = hd.querySelector('h2'); if (!t || r.top < 110 || r.bottom > vh - 30) return;
      const rg = document.createRange(); rg.selectNodeContents(t); const tr = rg.getBoundingClientRect();
      const act = hd.querySelector('.shelf-head-actions, .btn'); const end = act ? act.getBoundingClientRect().left - 24 : r.right;
      const from = tr.right + 24 + w * .6, room = end - w * .6 - from;
      if (room > 0) out.push({ x: from + Math.random() * room, y: tr.bottom - 2 });
    });
    return out;
  }
  function wander() {
    nextWander = 0;
    const vw = window.innerWidth, w = W(), r = Math.random();
    const cb = $('#cartBtn');
    if (hover && cb && r < .34 && Date.now() - lastBasketVisit > 60000) {
      const b = cb.getBoundingClientRect();
      lastBasketVisit = Date.now(); sess.set('eden-basket-visit', lastBasketVisit);
      attachEl = cb; attachKind = 'basket'; mode = 'attach'; tripRun = Math.random() < .5;
      modeUntil = Date.now() + 3500 + Math.hypot(b.left - bx, b.bottom - by) / SPEED.walk * 1000;
      basketNudge = cart.items.length > 0 && sess.get('eden-basket-nudge') !== '1';
      return;
    }
    tripRun = r > .82;
    // roam the whole screen, but only stop where nothing gets covered (see freeSpots)
    const spots = freeSpots().filter((p) => Math.hypot(p.x - bx, p.y - by) > 120);
    const p = spots.length ? spots[Math.floor(Math.random() * spots.length)] : { ...home(), fixed: true };
    tgx = p.x; tgy = p.y; onPageSpot = !p.fixed;
    mode = 'trot'; modeUntil = Date.now() + 20000;
  }
  function tick(t) {
    const dt = Math.min(64, (t || performance.now()) - lastT) / 1000; lastT = t || performance.now();
    if (!document.hidden && bOn) {
      const now = Date.now(), w = W();
      if (mode === 'attach' && attachEl && document.body.contains(attachEl)) {
        const at = attachTarget(attachEl.getBoundingClientRect(), w); tgx = at.x; tgy = at.y;
        if (now > modeUntil) { mode = 'follow'; attachEl = null; clickTrip = true; nextWander = 0; } // done visiting: move on to a free spot soon
      } else if (mode === 'attach') mode = 'follow';
      if ((mode === 'trot' || mode === 'enter') && now > modeUntil) mode = 'follow';
      if (mode === 'follow' && !hover && now - arrivedAt > 6000) { const h = perch(); tgx = h.x; tgy = h.y; }
      const dx = tgx - bx, dy = tgy - by, d = Math.hypot(dx, dy);
      let spd = 0;
      const gait = tripRun && d > 45 ? 'run' : mode === 'follow' ? 'stroll' : 'walk';
      if (d > 2) {
        const step = Math.min(d, SPEED[gait] * dt);
        bx += dx / d * step; by += dy / d * step; spd = step / (dt || 1 / 60);
        setState(gait === 'run' ? 'is-run' : 'is-walk');
        if (d - step <= 2) tripRun = false;
        if (Math.abs(dx) > 1) buddy.classList.toggle('is-right', dx > 0);
        arrivedAt = now;
        if (d - step <= 2 && mode === 'enter') mode = 'follow';
      } else if ((buddy.classList.contains('is-happy') || buddy.classList.contains('is-tilt')) && now > oneShotUntil) {
        setState('is-sit');
      } else if (!buddy.classList.contains('is-happy') && !buddy.classList.contains('is-tilt')) {
        if (mode === 'attach') {
          buddy.classList.toggle('is-right', attachKind === 'basket'); setState('is-scratch');
          if (attachKind === 'card' && Math.random() < .03) scratchMarks(bx - w * .45, by - H() * .55);
          if (attachKind === 'basket' && basketNudge && !bubble.classList.contains('is-on')) {
            basketNudge = false; sess.set('eden-basket-nudge', '1');
            const n = cart.item_count;
            showBubble(`<b>${esc(bName)}</b> is guarding your basket: ${n} ${n === 1 ? 'goodie' : 'goodies'} inside.`, '<div class="buddy-bubble__actions"><button class="btn btn--cta" type="button" id="buddyOpenCart">View basket</button></div>', 5000, 'basket');
          }
        } else if (now - lastMove > 30000) {
          const rp = hover ? { x: restX(), y: home().y } : perch();
          if (Math.abs(bx - rp.x) > 40 || Math.abs(by - rp.y) > 20) { tgx = rp.x; tgy = rp.y; } else setState('is-sleep');
        }
        else {
          setState('is-sit');
          // after running to a tap it moves on quickly, so it never parks on what the shopper is reading
          if (!nextWander) { nextWander = now + (clickTrip ? 1200 : 4000 + Math.random() * 7000); clickTrip = false; }
          else if (now > nextWander && !bubble.classList.contains('is-on') && panel.hidden) wander();
        }
      }
      anim.update(performance.now(), spd / (w / 210));
      buddy.style.transform = `translate(${bx - w / 2}px, ${by - H() * .937}px)`;
      placeBubble();
    }
    requestAnimationFrame(tick);
  }
  BUD = { suggest: suggestAfterAdd, hide: hideBubble };
  applyBuddy();
  refreshCart();
  if (reduce) { const h = home(); anim.set('sit'); anim.update(performance.now(), 0); buddy.style.transform = `translate(${h.x - W() / 2}px, ${h.y - H() * .937}px)`; setInterval(placeBubble, 250); }
  else { buddyEnter(); requestAnimationFrame(tick); }
})();
